import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ExpertManagerEventNotificationRecord } from '@libs/shared/api';
import { SprintLogoAvatarComponent } from '@libs/shared/ui/avatar/sprint-logo-avatar.component';
import { UserAvatarComponent } from '@libs/shared/ui/avatar/user-avatar.component';

@Component({
  selector: 'app-expert-console-manager-join-inquiry-declined-notification',
  standalone: true,
  imports: [CommonModule, SprintLogoAvatarComponent, UserAvatarComponent],
  template: `
    <div class="flex cursor-pointer flex-row gap-4">
      <!-- Icon -->
      @if (!eventNotification.notifier) {
        <app-sprint-logo-avatar />
      }
      <!-- Image -->
      @if (eventNotification.notifier) {
        <app-user-avatar [user]="eventNotification.notifier" />
      }
      <!-- Title, description & time -->
      <div class="flex w-full flex-col">
        <div class="line-clamp-1 font-semibold">
          센터 합류 요청이 거절되었어요.
        </div>
        <div class="text-secondary line-clamp-2">
          {{ eventNotification.expertConsole.name }}에 합류하시는 것이 맞는지 다시 한 번 확인해주세요.
        </div>
        <div class="text-secondary mt-2 text-sm leading-none">
          {{
            eventNotification.createdAt
              | date: 'yyyy-MM-dd (EEE), h:mm a'
          }}
        </div>
      </div>
    </div>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertConsoleManagerJoinInquiryDeclinedNotificationComponent {
  @Input({ required: true })
  eventNotification: ExpertManagerEventNotificationRecord;
}
